import React from "react";
import { useForm } from "react-hook-form";

import classes from "./save-point-modal.module.scss";

import { Modal } from "antd";
import Input from "../../../../components/form-items/input";
import classNames from "classnames";

const SavePointModal = ({
  isOpen,
  handleHide,
  defaultValues = {
    name: "",
  },
  onSubmit = () => {},
}) => {
  const {
    control,
    handleSubmit,
    formState: { isSubmitting, isDirty, errors },
  } = useForm({
    defaultValues,
  });

  return (
    <div>
      <Modal
        title="Save this point and coordinates"
        open={isOpen}
        footer={null}
        onCancel={handleHide}
        className={classes.FormModal}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={classes.Row}>
            <label className={classes.Label}>
              Enter comment for this point:
            </label>
            <Input control={control} name="comment" />
          </div>
          <div className={classes.Footer}>
            <div className={classes.SaveButtonWrap}>
              <button
                type="submit"
                className={classNames(classes.Button, "btn btn-primary")}
                disabled={isSubmitting || !isDirty}
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default SavePointModal;
